import Vue from 'vue'
import VueRouter from 'vue-router'
import packages from '../views/packages.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/packages/monthly-package-1' // Redirect root URL to the desired packageType
  },
  {
    path: '/packages/:packagetype',
    name: 'home',
    component: packages,
    props:true
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
